import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import './Graph.css';
import moment from 'moment-timezone';
import CustomTooltip from './CustomTooltip/CustomTooltip';
import { parsePrice } from '../../../../assets/utils/utils';

const customTickStyle = {
    fill: '#707B81',
    fontSize: '6.314px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '100%',
};

function Graph({
    data,
    period_type,
}) {
    const processedData = data.map((item, index) => ({
        ...item,
        showTick: period_type === 'day' ? index % 4 === 2 : period_type === 'week' ? 1 : index % 5 === 3,
    }));

    const CustomTooltipComponent = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <CustomTooltip
                    title={moment(label + '+00:00').format(period_type === 'day' ? 'HH:mm' : 'MMM DD')}
                    value={parsePrice(Number(payload[0].value), 'USD')}
                />
            );
        }

        return null;
    };

    const renderCustomAxisTick = (tickProps) => {
        const { x, y, payload } = tickProps;
        const currentItem = processedData.find(item => item.name === payload.value);

        if (currentItem && currentItem.showTick) {
            return (
                <g transform={`translate(${x},${y})`}>
                    <text x={0} y={0} dy={8} textAnchor="middle" style={customTickStyle}>
                        {moment(payload.value + '+00:00').format(period_type === 'day' ? 'HH:mm' : 'DD.MM')}
                    </text>
                </g>
            );
        }
        return null;
    };

    return (
        <div className='graph'>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={processedData}
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                >
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis
                        dataKey="name"
                        tick={renderCustomAxisTick}
                        interval={0}
                        axisLine={false}
                        tickLine={false}
                        height={30}
                    />
                    <YAxis
                        width={30} // ширина на всю левую область
                        axisLine={false}
                        tickLine={false}
                        tick={({ x, y, payload }) => (
                            <text
                                x={0}         // строго с самого левого края контейнера
                                y={y}
                                dy={4}
                                textAnchor="start"
                                style={customTickStyle}
                                
                            >
                                {parsePrice(Number(payload.value), 'USD')}
                            </text>
                        )}
                    />
                    <Tooltip content={<CustomTooltipComponent />} />
                    <Line
                        type="linear"
                        dataKey="value"
                        stroke="#000000"
                        strokeWidth={2}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default Graph;
